import { render, staticRenderFns } from "./ViFooter.vue?vue&type=template&id=4beb4401&scoped=true"
import script from "./ViFooter.vue?vue&type=script&lang=js"
export * from "./ViFooter.vue?vue&type=script&lang=js"
import style0 from "./ViFooter.vue?vue&type=style&index=0&id=4beb4401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb4401",
  null
  
)

export default component.exports